module.exports = __webpack_public_path__ + "static/img/logo01.d058c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo01.png
// module id = ywVb
// module chunks = 2